
// Compare


function initCompareSaveProductId () {
    $(".nt-compare").click(function() {
        $('.loader').show();

        var nt_compare_product_id = $(this).data('handle');
        var nt_compare_array = [];
        if(jQuery.cookie('nt-compare-product-id')) {
            nt_compare_array = jQuery.cookie('nt-compare-product-id')
            nt_compare_array = JSON.parse(nt_compare_array);
            var nt_compare_index = nt_compare_array.indexOf(nt_compare_product_id);
            if(nt_compare_index == -1){
                nt_compare_array.push(nt_compare_product_id)
            }

            jQuery.cookie('nt-compare-product-id', JSON.stringify(nt_compare_array), {expires:7, path:'/'});
        }else {
            nt_compare_array.push(nt_compare_product_id);
            jQuery.cookie('nt-compare-product-id', JSON.stringify(nt_compare_array), {expires:7, path:'/'});
        }
        //console.log(jQuery.cookie('nt-compare-product-id'));

        toastr.success('<span style="font-weight:bold">' + $(this).attr( "data-name" ) + ' </span>' + 'was successfully added to your' + '<a href="/pages/compare">' + 'Compare' + '</a>!');

        $(this).addClass('checked-compare');

        setTimeout(function(){

            $('.loader').hide();
        }, 500);

    })
}

function initCompareChecked () {

    if(jQuery.cookie('nt-compare-product-id')){
        var nt_compare_array = jQuery.cookie('nt-compare-product-id')
        nt_compare_array = JSON.parse(nt_compare_array);
        jQuery('a.nt-compare').each(function(){
            var nt_compare_handle = $(this).data('handle')
            var nt_compare_index = nt_compare_array.indexOf(nt_compare_handle);
            if(nt_compare_index >= 0){
                $(this).addClass('checked-compare');
            }
        })
    }

}
